import React from "react";
import PropTypes from "prop-types";

const Notices = ({ entity }) => {
  return (
    entity.region.urlPart === "houston" && (
      <div className="footer-links notices">
        <a
          href={`https://members.har.com/mhf/terms/dispBrokerinfo.cfm?sitetype=aws&cid=${entity.licenseNumber}`}
          target="_blank"
        >
          Texas Real Estate Commission Information About Brokerage Service
        </a>
        <br />
        <a
          href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-2.pdf"
          target="_blank"
        >
          Texas Real Estate Commission Consumer Protection Notice
        </a>
      </div>
    )
  );
};

Notices.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default Notices;



// WEBPACK FOOTER //
// ./src/components/shared/footer/notices.js